type KnownStatusses =
  | 'Beschikbaar'
  | 'Binnenkort beschikbaar'
  | 'Nu 1e maand gratis'
  | 'Offline'
  | 'Optie'
  | 'Onder optie'
  | 'Reacties gesloten'
  | 'Verhuurd'
  | 'Inschrijving gesloten'
  | 'Open huis reeds geweest'
  | 'Verkocht onder voorbehoud'
  | 'Verkocht'
  | 'Direct te huur';

type AdvertActions =
  | 'OPEN_FOR_REACTIONS'
  | 'NOT_OPEN_FOR_REACTIONS'
  | 'ALMOST_CLOSED_FOR_REACTIONS'
  | 'JUST_CLOSED_FOR_REACTIONS';

const CLOSED_FOR_REACTIONS: KnownStatusses[] = [
  'Reacties gesloten',
  'Verhuurd',
  'Offline',
  'Verkocht onder voorbehoud',
  'Verkocht',
  'Inschrijving gesloten',
];

const OPEN_FOR_REACTIONS: KnownStatusses[] = [
  'Beschikbaar',
  'Binnenkort beschikbaar',
  'Direct te huur',
  'Nu 1e maand gratis',
];

const ALMOST_CLOSED_FOR_REACTIONS: KnownStatusses[] = ['Open huis reeds geweest'];

const JUST_CLOSED_FOR_REACTIONS: KnownStatusses[] = [
  'Optie',
  'Onder optie',
];

export const mapAdvertStatusToAction = (advertStatus?: KnownStatusses | string | null): AdvertActions | null => {
  if (!advertStatus) return null;

  if (OPEN_FOR_REACTIONS.includes(advertStatus as KnownStatusses)) return 'OPEN_FOR_REACTIONS';

  if (CLOSED_FOR_REACTIONS.includes(advertStatus as KnownStatusses)) return 'NOT_OPEN_FOR_REACTIONS';

  if (ALMOST_CLOSED_FOR_REACTIONS.includes(advertStatus as KnownStatusses)) return 'ALMOST_CLOSED_FOR_REACTIONS';

  if (JUST_CLOSED_FOR_REACTIONS.includes(advertStatus as KnownStatusses)) return 'JUST_CLOSED_FOR_REACTIONS';

  return null;
};
